import { useEffect, useState } from 'react';

export default function ContactForm() {
    const [countries, setCountries] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        phone: '',
        country: ''
    });

    useEffect(() => {
  const fetchCountries = async () => {
    try {
      const urls = [
        'https://api.restcountries.com/countries/v5?response_fields=names.common,codes.alpha_2&limit=100&offset=0',
        'https://api.restcountries.com/countries/v5?response_fields=names.common,codes.alpha_2&limit=100&offset=100',
        'https://api.restcountries.com/countries/v5?response_fields=names.common,codes.alpha_2&limit=100&offset=200',
      ];

      const responses = await Promise.all(
        urls.map((url) =>
          fetch(url, {
            headers: {
              Authorization: 'rc_live_820cd25c9426448d83728c2a46aa9a49',
            },
          })
        )
      );

      for (const res of responses) {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
      }

      const results = await Promise.all(
        responses.map((res) => res.json())
      );

      const countriesData = results.flatMap(
        (result) => result.data.objects
      );

      const sorted = countriesData
        .filter((c) => c.codes?.alpha_2 && c.names?.common)
        .map((c) => ({
          cca2: c.codes.alpha_2,
          name: {
            common: c.names.common,
          },
        }))
        .sort((a, b) =>
          a.name.common.localeCompare(b.name.common)
        );

      setCountries(sorted);

    } catch (e) {
      console.error('Ошибка загрузки стран:', e);
    }
  };

  fetchCountries();
}, []);

    const onFormSubmit = async (event) => {
        event.preventDefault();
        const payload = {
            name: `${formData.name} ${formData.surname}`,
            email:  formData.email,
            country:   formData.country,
            phone:   formData.phone,
            amount: 'more 5000',
            issue_category: 'alpha',
            message: '0.0.0.0',
            brand_id: '66a23df5f21c5349afe8021e'
        };

        try {
            const response = await fetch(
                'https://safekonma.com/lead/register-lead-from-brand',
                {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(payload)
                }
            );
            if (!response.ok) {
                alert('Something went wrong. Please try again later.');
                return;
            }
            await response.json();
            console.log('Submitted data:', formData);
        } catch (e) {
            console.error('Error', e);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <form data-aos="fade-up" onSubmit={onFormSubmit}>
            <label>
                <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                />
            </label>

            <label>
                <input
                    type="text"
                    name="surname"
                    placeholder="Surname"
                    value={formData.surname}
                    onChange={handleChange}
                />
            </label>

            <label>
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                />
            </label>

            <label>
                <input
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    value={formData.phone}
                    onChange={handleChange}
                />
            </label>

            <label>
                <select name="country" value={formData.country} onChange={handleChange}>
                    <option value="">Select country</option>
                    {countries.map((country) => (
                        <option key={country.cca2} value={country.cca2}>
                            {country.name?.common}
                        </option>
                    ))}
                </select>

            </label>

            <button type="submit" className="button">Submit</button>
        </form>
    );
}
